import { Breadcrumbs } from '@/components/_common';
import { Link } from 'react-router-dom';
import { useAppSelector } from '@/redux/hooks';
import { selectPackagingContentAssembly } from '@/redux/selectors/packagingSelectors';
import { getLineageMetaTitle } from '@/_utils/utils';

const PackagingBreadcrumb = () => {
  const contentAssembly = useAppSelector(selectPackagingContentAssembly);
  const lineageMetaTitle = getLineageMetaTitle(contentAssembly?.version);

  return (
    <Breadcrumbs aria-label="breadcrumb">
      <Link to="/tasks">Tasks</Link>
      <Link to={`/tasks/?id=${contentAssembly?.id}`}>{contentAssembly?.hid}</Link>
      <span>{lineageMetaTitle}</span>
    </Breadcrumbs>
  );
};

export default PackagingBreadcrumb;
